const zIndex1 = 100
// const zIndex2 = 200;
const zIndex3 = 300
/* eslint-disable-next-line */
/* eslint-disable-next-line */
/* eslint-disable-next-line */
const zIndex6 = 600
const zIndex7 = 700
const zIndex8 = 800
const zIndex9 = 900
const zIndex10 = 1000
const zIndex11 = 1100
const zIndex12 = 1200
const zIndexNeg = -1

export default {
  negitive: zIndexNeg,
  zeroIndex: 0,
  normalZIndex: zIndex1,
  inputLabel: zIndex1,
  textContent: zIndex1,
  input: zIndex3,
  confirmTransactionModal: zIndex3,
  inputUnit: zIndex6,
  fixedTableHeader: zIndex7,
  filter: zIndex8,
  fixedTab: zIndex9,
  placeOrder: zIndex9,
  placeOrderWidth: zIndex10,
  dropdown: zIndex10,
  calendar: zIndex10,
  shade: zIndex10,
  footer: zIndex10,
  tradeOrders: zIndex10,
  tradePair: zIndex10,
  header: zIndex11,
  modal: zIndex11,
  loading: zIndex11,
  fullScreen: zIndex11,
  favorite: 1110,
  mobileLayout: zIndex12,
  routeLoading: zIndex12,
}
